import {
  createContext,
  forwardRef,
  useContext,
  type AnchorHTMLAttributes,
  type ComponentType,
  type ReactNode,
} from "react";

export type UiLinkProps = AnchorHTMLAttributes<HTMLAnchorElement> & {
  href: string;
  children?: ReactNode;
};

const PlainAnchor = forwardRef<HTMLAnchorElement, UiLinkProps>(function PlainAnchor(props, ref) {
  return <a ref={ref} {...props} />;
});

const LinkContext = createContext<ComponentType<UiLinkProps>>(PlainAnchor);

/**
 * How `@sarva/ui` renders an internal link. The package has no router, so by default a
 * link is a plain `<a>` — which in the SPA is a full page reload. The app supplies its
 * router's link here once (v3), and breadcrumbs, stat cards and linked rows navigate in
 * place.
 */
export function LinkProvider({
  component,
  children,
}: {
  component: ComponentType<UiLinkProps>;
  children: ReactNode;
}) {
  return <LinkContext.Provider value={component}>{children}</LinkContext.Provider>;
}

export function UiLink(props: UiLinkProps) {
  const Component = useContext(LinkContext);
  return <Component {...props} />;
}
